export default "__VITE_ASSET__B7AhcLO7__"